import React, { useEffect } from "react";
import { FilterModalSelect } from "./FilterModalSelect";
import { useDispatch, useSelector } from "react-redux";
import { fetchItems } from "../../../../../store/actions/items";
import { selectItems } from "../../../../../store/selectors/items";

export const AssetTypeFilter = ({ assetType, setSelectedAssetType }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchItems());
  }, [dispatch]);
  
  const assetTypes = useSelector((state) => [
    ...new Map(
      selectItems(state).map((item) => [item["typeName"], {name: item.typeName, value: item.typeId }])
    ).values(),
  ]);

  return (
    <FilterModalSelect
      label="Asset Type"
      value={assetType}
      onChange={setSelectedAssetType}
      placeholderText="Select Asset Type"
      options={assetTypes}
    />
  );
};
